import { render, staticRenderFns } from "./right-arrow.vue?vue&type=template&id=38fa9816&"
import script from "./right-arrow.vue?vue&type=script&lang=js&"
export * from "./right-arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports